// ** Type Import
import type { OwnerStateThemeType } from '.';

const DataGrid = () => {
  return {
    MuiDataGrid: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          border: 0,
          color: theme.palette.text.primary,
          '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none',
          },
        }),
        actionsCell: ({ theme }: OwnerStateThemeType) => ({
          '& .MuiButtonBase-root.MuiIconButton-root': {
            padding: theme.spacing(4),
          },
        }),
        toolbarContainer: ({ theme }: OwnerStateThemeType) => ({
          paddingRight: `${theme.spacing(5)} !important`,
          paddingLeft: `${theme.spacing(3.25)} !important`,
        }),
        columnHeaders: ({ theme }: OwnerStateThemeType) => ({
          backgroundColor: theme.palette.background.header,
        }),
        columnHeader: ({ theme }: OwnerStateThemeType) => ({
          '&:not(.MuiDataGrid-columnHeaderCheckbox)': {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            '&:first-of-type': {
              paddingLeft: theme.spacing(5),
            },
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(5),
          },
        }),
        columnHeaderCheckbox: {
          maxWidth: '58px !important',
          minWidth: '58px !important',
        },
        columnHeaderTitleContainer: {
          padding: 0,
        },
        columnHeaderTitle: {
          fontWeight: 600,
          fontSize: '0.75rem',
          letterSpacing: '0.17px',
          textTransform: 'uppercase',
        },
        columnSeparator: ({ theme }: OwnerStateThemeType) => ({
          color: theme.palette.divider,
        }),
        row: {
          '&:last-child': {
            '& .MuiDataGrid-cell': {
              borderBottom: 0,
            },
          },
        },
        cell: ({ theme }: OwnerStateThemeType) => ({
          '&:not(.MuiDataGrid-cellCheckbox)': {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            '&:first-of-type': {
              paddingLeft: theme.spacing(5),
            },
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(5),
          },
          '&:focus, &:focus-within': {
            outline: 'none',
          },
        }),
        'cell--editing': ({ theme }: OwnerStateThemeType) => ({
          padding: `0 !important`,
          '& .MuiInputBase-root.MuiOutlinedInput-root.MuiSelect-root': {
            lineHeight: `inherit`,
            borderRadius: 0,
            '& > div': {
              paddingLeft: `${theme.spacing(2)}`,
            },
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          },
          '& .MuiAutocomplete-root': {
            height: '100%',
            '& .MuiTextField-root': {
              height: '100%',
            },
            '& .MuiAutocomplete-inputRoot': {
              padding: `0`,
              height: '100%',
              '&::before': {
                borderBottom: 'none',
              },
              '& .MuiInput-input': {
                paddingTop: `${theme.spacing(1)}`,
                paddingBottom: `${theme.spacing(1)}`,
                paddingLeft: `${theme.spacing(2)}`,
                paddingRight: `${theme.spacing(2)}`,
                fontSize: '14px',
                height: '100%',
                border: 'none',
              },
            },
          },
        }),
        cellCheckbox: {
          maxWidth: '58px !important',
          minWidth: '58px !important',
        },
        editInputCell: ({ theme }: OwnerStateThemeType) => ({
          padding: 0,
          color: theme.palette.text.primary,
          '& input': {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
          },
        }),
        footerContainer: ({ theme }: OwnerStateThemeType) => ({
          borderTop: `1px solid ${theme.palette.divider}`,
          '& .MuiTablePagination-toolbar': {
            paddingLeft: `${theme.spacing(4)} !important`,
            paddingRight: `${theme.spacing(4)} !important`,
          },
          '& .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel': {
            color: theme.palette.text.primary,
          },
        }),
        selectedRowCount: ({ theme }: OwnerStateThemeType) => ({
          margin: 0,
          paddingLeft: theme.spacing(4),
          paddingRight: theme.spacing(4),
        }),
        menuIcon: ({ theme }: OwnerStateThemeType) => ({
          '& .MuiButtonBase-root.MuiIconButton-root': {
            padding: theme.spacing(2),
            '& svg': {
              width: '1rem',
              height: '1rem',
            },
          },
        }),
        iconButtonContainer: ({ theme }: OwnerStateThemeType) => ({
          '& .MuiButtonBase-root.MuiIconButton-root': {
            padding: theme.spacing(2),
            '& svg': {
              width: '1rem',
              height: '1rem',
            },
          },
          // Multi-sort index badge wraps `.MuiDataGrid-sortButton`
          '& .MuiBadge-root:has(> .MuiDataGrid-sortButton) > .MuiBadge-badge': {
            opacity: 0.55,
          },
        }),
      },
    },
  };
};

export default DataGrid;
